class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);



  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        // If theme has VAT toggle logic, explicitly re-apply prices after the grid re-renders.
        // This avoids needing a broad MutationObserver on collection pages.
        try {
          window.updateVatPrices?.();
        } catch (e) {
          // ignore
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    try {
      window.updateVatPrices?.();
    } catch (e) {
      // ignore
    }
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    container.innerHTML = count;
    container.classList.remove('loading');

    FacetFiltersForm.loadMore();
    FacetFiltersForm.initPriceIndector();

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
if (event.target.classList.contains('mobile-facets__checkbox')){
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static initPriceIndector(){
    const minInput = document.querySelector('input[id*="-GTE"]');
    const maxInput = document.querySelector('input[id*="-LTE"]');
    const currencyEl = document.querySelector('.field-currency');
    const wrapper = document.querySelector('.price-range-wrapper');
    if (!minInput || !maxInput || !currencyEl || !wrapper) return;

    // Prevent rebinding listeners if this is called multiple times (filters rerender / theme preview).
    if (wrapper.dataset.priceRangeInit === '1') {
      // Still refresh the UI (values may have changed after filter render)
      try {
        wrapper.__cstUpdateRange?.();
      } catch (e) {
        // ignore
      }
      return;
    }

    wrapper.dataset.priceRangeInit = '1';

    // Add filled bar
    const fill = document.querySelectorAll('.price-range-fill');

    // labels
    const lMin = document.querySelectorAll('.p-min');
    const lMid = document.querySelectorAll('.p-mid');
    const lMax = document.querySelectorAll('.p-max');

    const curency = currencyEl.innerHTML;
    const maxRange = parseInt(minInput.max);
    lMax.forEach((_t) => (_t.innerText = curency + maxRange));
    function updateRange() {
      let minVal = parseInt(minInput.value);
      let maxVal = parseInt(maxInput.value);

      // stop crossing
      if (minVal > maxVal) minInput.value = maxVal;
      if (maxVal < minVal) maxInput.value = minVal;

      minVal = parseInt(minInput.value);
      maxVal = parseInt(maxInput.value);

      let minPercent = (minVal / maxRange) * 100;
      let maxPercent = (maxVal / maxRange) * 100;

      fill.forEach(f=>f.style.left = minPercent + "%");
      fill.forEach(f=>f.style.width = (maxPercent - minPercent) + "%");

      // update labels
      lMin.forEach((_t) => (_t.innerText = curency + minVal));
      lMid.forEach((_t) => (_t.innerText = curency + maxVal));
    }

    // Allow subsequent calls (after rerender) to update without rebinding.
    wrapper.__cstUpdateRange = updateRange;

    minInput.addEventListener("input", updateRange);
    maxInput.addEventListener("input", updateRange);

    updateRange();
  }

  static loadMore(){
    
    const loadMoreButton = document.querySelector('.load-more-button');
    const productGrid = document.getElementById('product-grid');
    const loadingSpinner = document.querySelector('.loading-spinner');
    const viewedCountElement = document.querySelector('.viewed-count');

    if (loadMoreButton) {
      // Prevent duplicate click handlers when this method is called repeatedly.
      if (loadMoreButton.dataset.loadMoreBound === '1') return;
      loadMoreButton.dataset.loadMoreBound = '1';

      loadMoreButton.addEventListener('click', function () {
        const button = this;
        const nextUrl = button.getAttribute('data-next-url');
        const totalProducts = parseInt(button.getAttribute('data-total-products'));

        if (!nextUrl) return;

        // Hide button, show spinner (re-query spinner in case DOM was replaced by a prior load)
        button.style.display = 'none';
        const currentSpinner = document.querySelector('.loading-spinner');
        if (currentSpinner) currentSpinner.style.display = 'block';

        // Fetch next page — with auto-retry on 429 to recover from Elevar-triggered rate limits
        function doFetch(retryDelay) {
          fetch(nextUrl)
            .then((response) => {
              if (response.status === 429) {
                // Rate limited — wait then retry automatically
                setTimeout(() => doFetch(Math.min(retryDelay * 2, 8000)), retryDelay);
                return null;
              }
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.text();
            })
            .then((html) => {
              if (html === null) return; // waiting to retry

              const tempContainer = document.createElement('div');
              tempContainer.innerHTML = html;

              // Stagger product insertion in batches of 4 (200ms apart) so Elevar's
              // IntersectionObserver doesn't fire all product.js requests simultaneously,
              // which is what triggers Shopify's 429 rate limit in the first place.
              const newProductGrid = tempContainer.querySelector('#product-grid');
              if (newProductGrid) {
                const tempList = document.createElement('ul');
                tempList.innerHTML = newProductGrid.innerHTML;
                const items = Array.from(tempList.children);
                const BATCH = 4;
                const DELAY = 200;

                function insertBatch(index) {
                  items.slice(index, index + BATCH).forEach((item) => productGrid.appendChild(item));
                  if (index + BATCH < items.length) {
                    setTimeout(() => insertBatch(index + BATCH), DELAY);
                  }
                }
                insertBatch(0);
              }

              // Replace load-more container — guard against null on either side
              const LoadMoreContainer = document.querySelector('#load-more-container');
              const newLoadMoreContainer = tempContainer.querySelector('#load-more-container');
              if (LoadMoreContainer && newLoadMoreContainer) {
                LoadMoreContainer.innerHTML = newLoadMoreContainer.innerHTML;
              }

              // Update progress bar (re-query after DOM replacement)
              const currentViewed = document.querySelectorAll('#product-grid .grid__item').length;
              const total = parseInt(document.querySelector('.total-product-count')?.textContent) || totalProducts;
              const percent = total > 0 ? (currentViewed / total) * 100 : 0;
              const progressValue = document.querySelector('.cst-progress-value');
              if (progressValue) progressValue.style.width = `${percent}%`;

              // Update viewed count (re-query after DOM replacement)
              const freshViewedEl = document.querySelector('.viewed-count');
              if (freshViewedEl) freshViewedEl.textContent = Math.min(currentViewed, totalProducts);

              // Hide spinner (re-query after DOM replacement)
              const freshSpinner = document.querySelector('.loading-spinner');
              if (freshSpinner) freshSpinner.style.display = 'none';

              try { window.updateVatPrices?.(); } catch (e) { /* ignore */ }

              FacetFiltersForm.loadMore();
            })
            .catch((error) => {
              console.error('Error loading more products:', error);
              button.style.display = '';
              const freshSpinner = document.querySelector('.loading-spinner');
              if (freshSpinner) freshSpinner.style.display = 'none';
            });
        }
        doFetch(2000);
      });
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Initialize custom collection enhancements on first page load.
// Defer to idle time so we don't block initial interactivity on large collection pages.
// (These were previously duplicated inline in `main-collection-product-grid.liquid`.)
document.addEventListener('DOMContentLoaded', () => {
  const init = () => {
    try {
      FacetFiltersForm.loadMore();
    } catch (e) {
      // ignore
    }
    try {
      FacetFiltersForm.initPriceIndector();
    } catch (e) {
      // ignore
    }
    try {
      window.updateVatPrices?.();
    } catch (e) {
      // ignore
    }
  };

  // Use requestIdleCallback when available; otherwise fall back to a short timeout.
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(init, { timeout: 2000 });
  } else {
    setTimeout(init, 0);
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
